var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M14,17a1,1,0,0,1,1-1h7V1a1,1,0,0,0-1-1H3A1,1,0,0,0,2,1V23a1,1,0,0,0,1,1H14ZM5,5H19V7H5Zm0,5H19v2H5Zm6,7H5V15h6Z"}}),_c('polygon',{attrs:{"points":"21.414 18 16 18 16 23.414 21.414 18"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }